import React from 'react';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import TopBarProgress from 'react-topbar-progress-indicator';

import { ThemeToggle } from 'components';
import AuthWrapper from '../Wrapper';

const AuthLayout = (): JSX.Element => {
  return (
    <AuthWrapper>
      <div className='page-auth-login'>
        <div className='login-wrapper'>
          <section className='login-banner'>
            <div className='login-banner__copy'>
              <h1>Quản trị thông minh.</h1>
              <p>Một không gian tập trung cho dữ liệu và giao dịch.</p>
            </div>

            <div className='login-banner__art'>
              <img
                src='/assets/images/primary-login-banner.png'
                alt='Minh họa không gian quản trị an toàn'
              />
            </div>
          </section>

          <section className='login-panel'>
            <ThemeToggle className='login-panel__theme-toggle' />
            <Suspense fallback={<TopBarProgress />}>
              <Outlet />
            </Suspense>
          </section>
        </div>
      </div>
    </AuthWrapper>
  );
};

export default AuthLayout;
